import React, { Component } from "react";
import PropTypes from "prop-types";
import * as d3 from "d3";
import "./bars.style.scss";

class Bars extends Component {
  componentDidMount() {
    const { id, w, h, data } = this.props;
    this.drawChart({ id, w, h, data });
  }

  componentWillReceiveProps(nextProps) {
    const { id, w, h, data } = nextProps;

    if (
      w !== this.props.w ||
      JSON.stringify(data) !== JSON.stringify(this.props.data)
    ) {
      this.drawChart({ id, w, h, data });
    }
  }

  componentDidCatch(error, errorInfo) {
    console.log("catched error", error, errorInfo);
  }
  drawChart = ({ id, w, h, data }) => {
    if (!data || data.length === 0 || id === null || id === undefined) return;

    let select_ele = d3.select(`#${id}`);
    if (!select_ele[0][0]) {
      return;
    }

    select_ele.selectAll("svg").remove();

    const margin = { top: 10, right: 10, bottom: 10, left: 10 },
      width = w - margin.left - margin.right,
      height = h - margin.top - margin.bottom;

    const x = d3.scale.ordinal().rangeRoundBands([0, width], 0.05);
    const y = d3.scale.linear().range([height, 0]);

    let min_val =
      d3.min(data.map((d) => d.value)) > 0
        ? 0
        : d3.min(data.map((d) => d.value));
    let max_val =
      d3.max(data.map((d) => d.value)) < 0
        ? 0
        : d3.max(data.map((d) => d.value));

    x.domain(data.map((d) => d.x));

    y.domain([min_val, max_val]).nice();
    let Color = d3.scale.ordinal().range(["#9aecde", "#81acd9", "#5170a9"]);

    const svg = d3
      .select(`#${id}`)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    svg
      .selectAll("bar")
      .data(data)
      .enter()
      .append("rect")
      .style("fill", (d) => Color(d.x))
      .attr("x", (d) => x(d.x))
      .attr(
        "y",

        function (d) {
          if (d.value >= 0) {
            return y(d.value);
          } else {
            return y(0);
          }
        }
      )
      .attr("rx", 8)
      .attr("ry", 8)
      .attr("width", x.rangeBand())
      .attr("height", (d) => {
        return Math.abs(y(d.value) - y(0));
      })
      .append("title")
      .text(
        (d) => `${d.name} : ${d.value.toFixed(2)}% ${d.name2 && `(${d.name2})`}`
      );

    let text = svg.append("g").selectAll("text").data(data);

    text
      .enter()
      .append("text")
      .attr("class", "bar_labels")
      .style("font-size", "8px");

    text
      .attr("x", (d) => x(d.x))
      .attr("y", function (d) {
        if (d.value >= 0) {
          return y(d.value) - 2;
        } else {
          return y(0) + Math.abs(y(d.value) - y(0) + 10);
        }
      })
      .text((d) => d.value.toFixed(2) + "%");
  };
  render() {
    const { id, pl_35 } = this.props;
    return <div id={id} className={`${pl_35 ? "pl_35" : "my_bars"}`}></div>;
  }
}

Bars.propTypes = {
  id: PropTypes.string.isRequired,
};

export default Bars;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/bars/Bars.jsx